import { OptionTypes } from '../../../models/itinerary';
import { ActionTypes } from '../../constants/action-types';
import { SelectedRateReducerActions, SelectRateAction } from './types';

export interface SelectedRateReducerState {
  rate?: OptionTypes;
}

export const selectedRateInitialState: SelectedRateReducerState = {};

export function SelectedRateReducer(
  state = selectedRateInitialState,
  action: SelectedRateReducerActions,
): SelectedRateReducerState {
  switch (action.type) {
    case ActionTypes.RATE_SELECT:
      const { rate } = action as SelectRateAction;
      return { ...state, rate };
    case ActionTypes.RATE_CLEAR:
      return {};
    default:
      return state;
  }
}
